module.exports = __webpack_public_path__ + "img/1_01.abb621aa.jpg";